import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { CreateFMEAInput, CreateFMEAOutput, StreamEvents } from '@/types/index';
import { CreateApi } from '@/infrastructure/api-functions/create-api';
import type { SSEResponse, type PsHttpSSE } from '@patsnap-utils/sse';

export const CreateService = Symbol('CreateService');

export interface CreateService {
    createFMEA(input: CreateFMEAInput): Promise<CreateFMEAOutput>;
    getProgress<T>(fmea_id: string, streamEvents?: StreamEvents): PsHttpSSE<T>;
}

@injectable()
export class CreateServiceImpl implements CreateService {
    constructor(
        @inject(CreateApi)
        private createApi: CreateApi
    ) {
    }

    createFMEA(input: CreateFMEAInput): Promise<CreateFMEAOutput> {
        return this.createApi.createFMEA(input)
    }

    getProgress<T>(fmea_id: string, streamEvents?: StreamEvents): PsHttpSSE<T> {
        return this.createApi.getProgressStream<T>(fmea_id)
            .onOpen((response: Response) => {
                console.log('==> onOpen', response)
                streamEvents?.onOpen && streamEvents.onOpen(response)
            })
            .onMessage((data: SSEResponse<T>) => {
                streamEvents?.onMessage && streamEvents.onMessage(data)
            })
            .onFinish(() => {
                console.log('==> onFinish')
                streamEvents?.onFinish && streamEvents.onFinish()
            })
            .onError((err: any) => {
                console.log('==> onError', err)
                streamEvents?.onError && streamEvents.onError(err)
            })
            .onClose(() => {
                console.log('==> onClose')
                streamEvents?.onClose && streamEvents.onClose()
            });
    }
}
